// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alerts_alerts-inner-container_eFr4W {\n    min-width: 200px;\n    max-width: 548px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/alerts/alerts.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".alerts-inner-container {\n    min-width: 200px;\n    max-width: 548px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alerts-inner-container": "alerts_alerts-inner-container_eFr4W",
	"alertsInnerContainer": "alerts_alerts-inner-container_eFr4W"
};
export default ___CSS_LOADER_EXPORT___;
